/* Publish by EComposer at 2026-10-11 17:29:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rg9gnghc1lh"]=  window.__ectimmers["ecom-rg9gnghc1lh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rg9gnghc1lh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rg9gnghc1lh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l98g6vlibua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l98g6vlibua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f25zqbtbg4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f25zqbtbg4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4b2vf8ryaor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4b2vf8ryaor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2pincohvgq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2pincohvgq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhzt8gavz3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhzt8gavz3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzd62elqyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzd62elqyc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gesf3bu0qwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gesf3bu0qwk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9hfphyp8ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9hfphyp8ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19ut288r9yh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19ut288r9yh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi5m3sgyp3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi5m3sgyp3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53749waw0y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53749waw0y9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koirskuoclr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koirskuoclr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qwtgjkvng2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qwtgjkvng2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2297tn08vo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2297tn08vo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-suewzhakn1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-suewzhakn1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lb481j5tdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lb481j5tdp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7b0zr05lz6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7b0zr05lz6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5izs83ed0hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5izs83ed0hn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wb7f2or71x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wb7f2or71x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhb801ul1er').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhb801ul1er', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g3bhalpnh2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g3bhalpnh2n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlnsdgbes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlnsdgbes', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qdraachbqgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qdraachbqgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iuwn8c1ymr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iuwn8c1ymr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7fe52n8487').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7fe52n8487', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6b8b34lp9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6b8b34lp9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qj3f2xjrp2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qj3f2xjrp2k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2kwbkvysimo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2kwbkvysimo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ndp4zjziea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ndp4zjziea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwylpgkyb2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwylpgkyb2s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hywycdtjoxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hywycdtjoxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ozpdrdtpt6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ozpdrdtpt6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c49tum1icv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c49tum1icv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uppq3jextv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uppq3jextv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulzndguhqy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulzndguhqy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4v3io9ljqqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4v3io9ljqqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hix8qh5xxwv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hix8qh5xxwv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvy6yvlezp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvy6yvlezp8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pm72b1j14').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pm72b1j14', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0vmmw88esp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0vmmw88esp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-skj23b8hvfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-skj23b8hvfm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ek0d2zu5nmw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ek0d2zu5nmw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arppe7x6g47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arppe7x6g47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fqoi57tw0ed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fqoi57tw0ed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5fjr8at6co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5fjr8at6co', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ve24q7jl5ol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ve24q7jl5ol', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gakuwe1f7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gakuwe1f7q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5yh7kyxnr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5yh7kyxnr8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idupgd7ribh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idupgd7ribh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3pxpndbza4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3pxpndbza4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2snzbne4vgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2snzbne4vgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pfr5jg8mu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pfr5jg8mu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nh8y4siua3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nh8y4siua3b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3z8rlfpza3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3z8rlfpza3t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2ovcam8x7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2ovcam8x7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxbmzurkmss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxbmzurkmss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0fcrttopjhnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0fcrttopjhnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsdzip4np4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsdzip4np4k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e3qya8x4a2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e3qya8x4a2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4fqtkhm94n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4fqtkhm94n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8ffkfsvo5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8ffkfsvo5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uz8gxxu26k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uz8gxxu26k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avcxa1y3yht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avcxa1y3yht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv2dafjk0xs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv2dafjk0xs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4i0jg81teyx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4i0jg81teyx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysxrul3mbgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysxrul3mbgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-prbkg2sb3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-prbkg2sb3w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s60bvx18e7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s60bvx18e7s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arckmstxooq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arckmstxooq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-42vmu0838ak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-42vmu0838ak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aemfvq8c8wl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aemfvq8c8wl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f94m30lfo0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f94m30lfo0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nliw9hjyhp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nliw9hjyhp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-316hgktprye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-316hgktprye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-253z4eaa0fl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-253z4eaa0fl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jlrfu1d5e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jlrfu1d5e4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zc5b04qws2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zc5b04qws2i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpwhhhku68d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpwhhhku68d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmlbq0fi7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmlbq0fi7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1adwt0gk7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1adwt0gk7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbg9pravgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbg9pravgs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4erfnho86e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4erfnho86e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3c2nrfl6mv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3c2nrfl6mv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3bml1ug0w7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3bml1ug0w7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7uo1pdz8wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7uo1pdz8wc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bx238twkner').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bx238twkner', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ln2mv3hyy0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ln2mv3hyy0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9td4mram9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9td4mram9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ofhrqvxg45f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ofhrqvxg45f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvxpq5l3eei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvxpq5l3eei', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vy97bovgsh"]=  window.__ectimmers["ecom-vy97bovgsh"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-vy97bovgsh"]["1h9wmx88a"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-vy97bovgsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vy97bovgsh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtei6z5hk8d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtei6z5hk8d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjslu3041he').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjslu3041he', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mtvclqfnj3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mtvclqfnj3i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgb2lbdtvdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgb2lbdtvdg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rugtc06tjhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rugtc06tjhc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9mw5l6n93').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9mw5l6n93', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73025kpgg92').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73025kpgg92', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dbzfkp7qgmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dbzfkp7qgmo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0cjnhrxec7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0cjnhrxec7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fkf7xlkeirf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fkf7xlkeirf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vk754yrv1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vk754yrv1b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30zkmxun20d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30zkmxun20d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhxkd7ooydo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhxkd7ooydo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6g9f8z93oqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6g9f8z93oqb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uv4qroc7em').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uv4qroc7em', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18rks8qygh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18rks8qygh8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qs7idl079v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qs7idl079v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0jjirnsjhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0jjirnsjhe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-909o9ve0rof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-909o9ve0rof', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2lp2a7b1yuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2lp2a7b1yuk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7o8sflt0po8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7o8sflt0po8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ukow2dligm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ukow2dligm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lm4fb3x0lk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm4fb3x0lk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8dfcx4jg73i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8dfcx4jg73i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf8v5dttp5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf8v5dttp5v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czhemh7ew4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czhemh7ew4r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wb5lpbk1ox').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wb5lpbk1ox', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll26i3ol35a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll26i3ol35a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-826mwh4esjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-826mwh4esjf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v20pm4a0itm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v20pm4a0itm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-noiwmr0wdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-noiwmr0wdf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-il7gli1cau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-il7gli1cau', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fgivdlcotm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fgivdlcotm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iitb7cuti4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iitb7cuti4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9dfmg9mfz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9dfmg9mfz8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d68y9jw9ngq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d68y9jw9ngq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkv7qu19s2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkv7qu19s2c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c2t8dtkv7zq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c2t8dtkv7zq', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8ylzbl19enc"]=  window.__ectimmers["ecom-8ylzbl19enc"] || {};
var S,L,F,j,I,E;let t=this.$el;if(!t)return;let e=this.isLive;const i=(S=this.settings.disable_auto_close)!=null?S:!1,o=(L=this.settings.disable_auto_close__tablet)!=null?L:!1,n=(F=this.settings.disable_auto_close__mobile)!=null?F:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(I=this.settings.disable_effect)!=null?I:!1,a=(E=this.settings.close_all)!=null?E:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(T){const B=T.getBoundingClientRect();return B.top>=0&&B.left>=0&&B.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&B.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return n&&T<768||o&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const B=T.style.transition;T.style.transition="none",T.style.height="auto";const O=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=B,requestAnimationFrame(()=>{const N=r?"auto":e?O+"px":"auto";T.style.height=N})}function y(T){T.classList.remove("ecom-item-active");const B=T.querySelector(":scope > .ecom-accordion__body");B&&(r||(B.style.height=B.scrollHeight+"px",B.offsetHeight),requestAnimationFrame(()=>{B.style.height="0px"}))}function v(T){let B=0;if(T.offsetParent)do B+=T.offsetTop;while(T=T.offsetParent);return B}function w(T){const B=Math.max(0,T),O=window.pageYOffset||document.documentElement.scrollTop,N=B-O;if(N===0)return;const Z=300;let K=null;function W(oe){K||(K=oe);const se=Math.min((oe-K)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,O+N*Y),se<1&&window.requestAnimationFrame(W)}window.requestAnimationFrame(W)}function k(T){w(v(T)-100)}function $(T,B=!1){T.forEach((O,N)=>{const Z=O.parentNode,K=Z.querySelector(":scope > .ecom-accordion__body");!r&&K&&K.classList.add("ecom-effect-accodion");const W=Z.classList.contains("ecom-item-active");K&&!a&&(B&&N===0||W)&&requestAnimationFrame(()=>{K.style.height=K.scrollHeight+"px"}),O.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,ue=Y.parentNode,ge=ue.querySelectorAll(":scope > .ecom-accordion__item"),de=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),Q=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),V=_(se);if(U)V?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),de.forEach(fe=>fe.classList.remove("ecom-item-active")));else{V||(ge.forEach(y),de.forEach(Ee=>Ee.classList.remove("ecom-item-active"))),O.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&Q&&Q.classList.add("ecom-effect-accodion"),b(Q)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ce=s||se>1024;function J(){window.dispatchEvent(new window.Event("renderScroll")),ce&&!m(X)&&k(X)}if(ce&&!r){let fe;const Ee=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{ue.removeEventListener("transitionend",Ee),J()},50))};ue.addEventListener("transitionend",Ee),setTimeout(()=>{ue.removeEventListener("transitionend",Ee),J()},600)}else requestAnimationFrame(()=>{setTimeout(J,100)})}})}$(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function z(){const T=window.location.hash;if(T){const B=t.querySelector(`[data-target="${T}"]`);if(B){B.click(),B.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=B.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>$(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-8ylzbl19enc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ylzbl19enc', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogi8qhr7pb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogi8qhr7pb', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x22qwwdhazr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x22qwwdhazr', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7dlaankuayo"]=  window.__ectimmers["ecom-7dlaankuayo"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-7dlaankuayo"]["vybgoe0ns"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-7dlaankuayo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dlaankuayo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f565h4mghmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f565h4mghmf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7uhvsvdtel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7uhvsvdtel', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmzz0ulev27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmzz0ulev27', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4yf93c0qtr5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4yf93c0qtr5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j53fk16mr6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j53fk16mr6q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1rcmm1db4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1rcmm1db4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wdgouf7ueg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wdgouf7ueg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o87vutq18sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o87vutq18sr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4muvtmrpu6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4muvtmrpu6n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zum1yo8tnr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zum1yo8tnr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbqsbfhau0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbqsbfhau0g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki7r84jb09g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki7r84jb09g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxxuo7qq3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxxuo7qq3w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a87bfs8czxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a87bfs8czxh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hnfino9kfb"]=  window.__ectimmers["ecom-hnfino9kfb"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(_)},500);function b(F){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(F)}function y(F,j){let I={handleMouseenter:E,handleMouseleave:T,handleEnded:B};function E(){F.readyState>=c&&F.pause()}function T(){F.readyState>=c&&F.play()}function B(){v(F,I)}if(r){F.addEventListener("mouseenter",E),F.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",E),O.addEventListener("mouseleave",T)),j||F.addEventListener("ended",B)}}function v(F,j){if(j){const{handleMouseenter:I,handleMouseleave:E,handleEnded:T}=j;let B=t.querySelector(".ecom-video_link-extra");F.removeEventListener("mouseenter",I),F.removeEventListener("mouseleave",E),F.removeEventListener("ended",T),B&&B.href&&(B.removeEventListener("mouseenter",I),B.removeEventListener("mouseleave",E))}}function w(F,j){F.forEach(function(I){if(I.isIntersecting){const E=I.target.querySelector("video source"),T=I.target.querySelector("video"),B=I.target.querySelector("iframe");if(T&&E&&(E.src=E.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),B){let O=B.dataset.srcVideo;B.setAttribute("src",O)}j.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),$=t.querySelector(".ecom_iframe");a&&k&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if($){let F=$.getAttribute("src");F.includes("autoplay=0")?F=F.replace("autoplay=0","autoplay=1"):F=F+"&autoplay=1",$.setAttribute("src",F),l?setTimeout(()=>{F=F.replace("autoplay=1","autoplay=0"),$.setAttribute("src",F)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(F){F.dataset.ecTrackingId&&F.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:F.id,tracking_id:F.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]"),S=function(F){if(window.EComModal)return F();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&F()});return}let j=0;const I= window.__ectimmers["ecom-hnfino9kfb"]["t5ad1il9b"] = setInterval(function(){window.EComModal?(clearInterval(I),F()):++j>=300&&clearInterval(I)},50)},L=this.id;z&&this.settings.image_overlay&&l&&S(function(){const F=z.dataset.width,j=z.dataset.height;var I=L;new window.EComModal(z,{cssClass:[I,"ecom-core","ecom-core-simulator"],onOpen:function(){var E=document.querySelector(".ecom-modal."+I);if(E){const T=E.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const B={width:F,height:j};Object.assign(T.style,B)}},onClose:function(){var E=document.querySelector(".ecom-modal."+I);if(E){const T=E.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-hnfino9kfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnfino9kfb', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}